import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import cn from "classnames";
import withStyles from "components/with-styles";
import styles from "./styles/data-grid.css.js";

const DataGrid = ({ className, children, classes, withPadding = true }) => (
  <Grid className={cn({ [classes.datagrid]: withPadding }, className)} container textalign="center" spacing={3}>
    {children}
  </Grid>
);

DataGrid.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Indica si lleva o no padding
   */
  withPadding: PropTypes.bool,
};

export default withStyles(styles)(DataGrid);
